class BlueLightAddon extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('[name="blue_light_addon"]');
    this.productInfo = this.closest('[data-section-type="product"]');
    this.productForm = this.productInfo && this.productInfo.querySelector('product-form');
    if (!this.productForm || !this.checkbox || !this.productInfo) return;

    const submitBtn = this.productForm.querySelector('[data-add-to-cart]');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    if (!this.checkbox.checked) return;

    const coatingId = this.dataset.coatingVariantId;
    if (!coatingId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitBtn = event.currentTarget;
    const variantInput = this.productForm.querySelector('[name="id"]');
    const quantityInput = this.productForm.querySelector('[name="quantity"]');
    const notifications = document.querySelectorAll('cart-notification');
    const cartNotification = notifications[notifications.length - 1];

    const mainVariantId = parseInt(variantInput && variantInput.value);
    const quantity = parseInt((quantityInput && quantityInput.value) || '1');
    if (!mainVariantId) return;

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    if (cartNotification) cartNotification.setActiveElement(document.activeElement);

    const sectionIds = cartNotification
      ? cartNotification.getSectionsToRender().map(s => s.id).join(',')
      : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: mainVariantId, quantity },
          {
            id: parseInt(coatingId),
            quantity,
            properties: {
              'Note': 'Blue Light Blocking Coating is custom made — please allow 10–14 business days for your order.'
            }
          }
        ],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          if (typeof this.productForm.handleErrorMessage === 'function') {
            this.productForm.handleErrorMessage(data.description);
          }
          return;
        }
        if (cartNotification && data.items && data.items.length > 0) {
          cartNotification.renderContents({
            id: data.items[0].id,
            sections: data.sections
          });
        }
      })
      .catch(err => console.error('Blue light addon error:', err))
      .finally(() => {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-disabled');
      });
  }
}

if (!customElements.get('blue-light-addon')) {
  customElements.define('blue-light-addon', BlueLightAddon);
}
